__turbopack_context__.v({
  "map": "iframe-map-module__MdgAeG__map",
});
